<template>
  <v-container>
    <div class="elevation-5">
      <v-toolbar>
          <v-menu
            :close-on-content-click="true"
            v-model="mStartDate"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="230px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dStart" label="开始日期" clearable prepend-icon="event" readonly v-bind="attrs" v-on="on"
                style="width:40px;"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dStart" locale="zh-cn"></v-date-picker>
          </v-menu>
          <v-menu
            :close-on-content-click="true"
            v-model="mEndDate"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dEnd" label="结束日期" clearable prepend-icon="event" readonly v-bind="attrs" v-on="on"
                style="width:40px;"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dEnd" locale="zh-cn"></v-date-picker>
          </v-menu>
          <v-text-field
            v-model="search_str"
            label="搜索"
            prepend-icon="search"
            clearable
            dense
            style="width:100px;"
            >
          </v-text-field>
          <v-btn @click="reload" small color="success" style="margin-left:10px;"><v-icon>search</v-icon>搜索</v-btn>
          <v-btn @click="toexcel" small color="info" style="margin-left:10px;"><v-icon>list_alt</v-icon>导出xlsx</v-btn>
      </v-toolbar>
      <v-toolbar dense>
          <v-checkbox v-model="sOutDate" style="width:130px;" label="发出日期"></v-checkbox>
          <v-checkbox v-model="sInDate" style="width: 130px;" label="收回日期"></v-checkbox>
          <v-checkbox v-model="sUnreturn" style="width: 130px;" label="发出未收回"></v-checkbox>
      </v-toolbar>
    </div>
    <v-data-table
      :items="items"
      :headers="headers"
      :server-items-length="pgn.totalItems"
      hide-default-footer
      class="elevation-2"
    >
      <template v-slot:item.handle="{item}">
        <v-tooltip bottom v-if="item.status === 1 && canUnsend">
          <template v-slot:activator="{on, attrs}">
            <v-btn x-small icon v-bind="attrs" v-on="on"
              @click="unsendCage(item)" color="error">
                <v-icon>backspace</v-icon>
            </v-btn>
          </template>
          <span>取消发出</span>
          </v-tooltip>
        <v-tooltip bottom v-if="item.canDereturn && canDereturnCage">
          <template v-slot:activator="{on, attrs}">
            <v-btn x-small icon v-bind="attrs" v-on="on"
              @click="deReturnCage(item.id, item.cage_no)" color="error">
                <v-icon>close</v-icon>
            </v-btn>
          </template>
          <span>取消收回</span>
          </v-tooltip>
      </template>
      <template slot="no-data">
        没有记录
      </template>
    </v-data-table>
    <div style="font-size:12px;">
      总数: {{ pgn.totalItems }}, 已发出未收回仓储笼个数: {{ unreturn_cnt }}
    </div>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pgn.page" :length="pgn.totalPages"></v-pagination>
    </div>
  </v-container>
</template>

<style>

</style>

<script>
import { Date2Int, Int2Date } from '@/libs/util'
import { getCageHis, unsendCage, deReturnCage } from '@/api/cage'
import { baseURLAPI, TOKEN_KEY } from '@/config'
import Cookies from 'js-cookie'
import { canDo } from '@/libs/tools'

export default {
  components: {
  },
  data: () => ({
    mStartDate: false,
    mEndDate: false,
    dStart: '',
    dEnd: '',
    search_str: '',
    items: [],
    pgn: {
      page: 1,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    headers: [
      { text: '仓储笼号', value: 'cage_no', sortable: false, width: 120 },
      { text: '发出日期', value: 'a_out', sortable: false, width: 120 },
      { text: '收回日期', value: 'a_in', sortable: false, width: 120 },
      { text: '备注', value: 'note', sortable: false },
      { text: '装笼', value: 'products', sortable: false },
      { text: '操作', value: 'handle', sortable: false }
    ],
    sOutDate: false,
    sInDate: false,
    sUnreturn: false,
    unreturn_cnt: 0
  }),
  computed: {
    canUnsend () {
      return canDo(['admin', 'unsendcage'], this.$store.state.user.access)
    },
    canDereturnCage () {
      return canDo(['admin', 'dereturncage'], this.$store.state.user.access)
    }
  },
  watch: {
    pgn: {
      handler () {
        this.reload()
      },
      deep: true
    }
  },
  methods: {
    deReturnCage(cage_id, cage_no) {
      this.$swal.fire({
        title: '警告',
        text: '确实要取消收回' + cage_no + '号仓储笼吗? ',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDereturnCage(cage_id);
        }
      })
    },
    doDereturnCage(cage_id) {
      deReturnCage(cage_id).then(res => {
        this.reload();
      })
    },
    doUnsend (id) {
      unsendCage(id).then(res => {
        this.reload()
      })
    },
    unsendCage (item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要取消[' + item.cage_no + '号仓储笼]发出吗?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doUnsend(item.id);
        }
      })
    },
    toexcel () {
      let start = Date2Int(this.dStart)
      let end = Date2Int(this.dEnd)
      let kw = this.search_str === undefined ? '' : this.search_str
      let indate = this.sInDate ? 1 : 0
      let outdate = this.sOutDate ? 1 : 0
      let unreturn = this.sUnreturn ? 1 : 0
      let token = Cookies.get(TOKEN_KEY)
      var w = window.open('', '_blank')
      let url = baseURLAPI + 'cage/his/toexcel'
      w.document.write(`<html><head>
                          <script>
                            function ff() {
                              this.form.submit();
                            }
                          <\/script>
                        </head><body>
                        <form name="form" method="post" action="` + url + `">
        <input type="hidden" name="start" value="` + start + `" />
        <input type="hidden" name="end" value="` + end + `" />
        <input type="hidden" name="kw" value="` + kw + `" />
        <input type="hidden" name="indate" value="` + indate + `" />
        <input type="hidden" name="outdate" value="` + outdate + `" />
        <input type="hidden" name="unreturn" value="` + unreturn + `" />
        <input type="hidden" name="token" value="` + token + `" />
        </form></body></html>`
      )
      w.ff()
    },
    in3Days(dn) {
      var d = new Date()
      d.setDate(d.getDate() - 3);
      let d3 = Date2Int(d);
      return (dn > d3);
    },
    reload () {
      let d = {
        'kw': this.search_str,
        'indate': this.sInDate ? 1 : 0,
        'outdate': this.sOutDate ? 1 : 0,
        'unreturn': this.sUnreturn ? 1 : 0,
        'start': Date2Int(this.dStart),
        'end': Date2Int(this.dEnd),
        'page': this.pgn.page,
        'perPage': this.pgn.rowsPerPage
      }
      this.unreturn_cnt = 0
      getCageHis(d).then(res => {
        this.items = res.data.items
        this.items.forEach(e => {
          e.p_out_s = Int2Date(e.p_out)
          e.p_in_s = Int2Date(e.p_in)
          e.a_out_s = Int2Date(e.a_out)
          e.a_in_s = Int2Date(e.a_in)
          e.products = e.products.replace(/\n/g, '<br>')
          e.canDereturn = (e.status === 2 && e.cage_st === 0 && this.in3Days(e.a_in));
        })
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pgn.page = res.data._meta.total_pages
        } else {
          this.pgn.page = res.data._meta.page
        }
        this.pgn.totalPages = res.data._meta.total_pages
        this.pgn.totalItems = res.data._meta.total_items
        this.unreturn_cnt = res.data.unreturn_cnt
      })
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
